export default __webpack_public_path__ + "static/media/logoBlogBlack.ed7e804c.png";